import { 
	DEACTIVATE_DENY, ACTIVATE_DENY, CREATE_DENY, UPDATE_DENY, GET_ERRORS, GET_DENIALS 
} from "../actions/types";

const initialState = {
	actionType: '',
	denials:    [],
	error:      {},
};

export default function (state = initialState, action) {
	switch (action.type) {
		case CREATE_DENY:
			return {
				...state,
				actionType: action.type,
				success:    'La denegación fue creada exitosamente.'
			};
		case UPDATE_DENY:
			return {
				...state,
				actionType: action.type,
				success:    'La denegación fue actualizada exitosamente.'
			};
		case GET_DENIALS:
			return {
				...state,
				actionType: action.type,
				denies:      action.payload.message,
				success:    'Se obtuvieron ' + action.payload.message.length + " denegaciones."
			};
		case DEACTIVATE_DENY:
			return {
				...state,
				actionType: action.type,
				success:    'La denegación fue desactivada exitosamente.'
			};
    case ACTIVATE_DENY:
      return {
        ...state,
        actionType: action.type,
        success:    'La denegación fue activada exitosamente.'
      };
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				message:    action.payload
			};
		default:
			return state;
	}
}